import { Injectable } from '@angular/core'
import { from, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { IntegrationsApiService } from 'src/app/builder-services/api/integrations.api.service'
import { BuilderService } from '../builder-services/builder.service'

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {
  project_id = this.builderService.selectedProject
  public integrationsData: any
  constructor(private builderService: BuilderService, private integrationsApi: IntegrationsApiService) {}

  setIntegrations = (integrations: any) => {
    this.builderService.showUpdateProgress = true
    return new Observable<any>((observer) => {
      from(this.integrationsApi.saveIntegrations(String(this.project_id), integrations)).subscribe({
        next: (response) => {
          this.builderService.showUpdateProgress = false
          observer.next(response)
          observer.complete()
        },
        error: (error) => {
          this.builderService.showUpdateProgress = false
          observer.error(error)
        }
      })
    })
  }

  getIntegrations = () => {
    this.builderService.showUpdateProgress = true
    return new Observable<any>((observer) => {
      from(this.integrationsApi.getIntegrations(String(this.project_id))).subscribe({
        next: (response) => {
          this.integrationsData = response
          this.builderService.showUpdateProgress = false
          observer.next(response)
          observer.complete()
        },
        error: (error) => {
          this.builderService.showUpdateProgress = false
          observer.error(error)
        }
      })
    })
  }

  setIntegrationConnected = (provider: string, connected: boolean): Observable<void> => {
    return from(this.integrationsApi.setIntegrationConnected(String(this.project_id), provider, connected))
  }

  getWordpressSiteUrl = (): Observable<string> => {
    return from(this.integrationsApi.getIntegrations(String(this.builderService.selectedProject))).pipe(
      map((data: any) => data?.wordpress_site_url || '')
    )
  }

  saveZohoToken = (token: any) => {
    return new Observable<any>((observer) => {
      this.getIntegrations().subscribe((currentData) => {
        const newData = currentData || {}
        newData.zohoToken = token

        this.setIntegrations(newData).subscribe(
          (response) => {
            observer.next(response)
            observer.complete()
          },
          (err) => observer.error(err)
        )
      })
    })
  }
}
